import { Button } from 'framework/ui/mui-builder';
import { PropsWithChildren } from 'react';

const BUTTON_SX = {
  minWidth: 0,
  maxWidth: '100%',
  p: 0,
  textTransform: 'none',
  justifyContent: 'flex-start',
  fontSize: 14,
  fontWeight: 600,
  lineHeight: 1.25,
  textAlign: 'left',
  color: 'primary.main',
  overflow: 'hidden',
  flexShrink: 1,
  '&:hover': {
    textDecoration: 'underline',
  },
} as const;

type InterruptionCreatorButtonProps = PropsWithChildren<{
  onClick: () => void;
  title: string;
}>;

const InterruptionCreatorButton = ({ children, onClick, title }: InterruptionCreatorButtonProps) => (
  <Button variant="text" onClick={onClick} title={title} sx={BUTTON_SX}>
    {children}
  </Button>
);

export default InterruptionCreatorButton;
